"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.httpRequestForArrayBufferPt = exports.httpRequestForDept = exports.downloadPdfFile = exports.commonApiPost = exports.loginRequestEmployee = exports.loginRequest = exports.uploadFileHandler = exports.uploadSingleFilePt = exports.uploadFileForPt = exports.uploadFile = exports.httpRequestForArrayBuffer = exports.httpRequestForAssessee = exports.httpRequestForPT = exports.httpRequestForPTKMC = exports.httpRequestForBnd = exports.httpRequest = exports.httpRequestWF = exports.httpRequestPGR = exports.httpRequestCH = exports.multiHttpRequest = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _common = require("config/common.js");

var _common2 = _interopRequireDefault(_common);

var _actions = require("egov-ui-kit/redux/common/actions");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _actions2 = require("egov-ui-kit/redux/app/actions");

var _cryptoJs = require("crypto-js");

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _some = require("lodash/some");

var _some2 = _interopRequireDefault(_some);

var _store = require("ui-redux/store");

var _store2 = _interopRequireDefault(_store);

var _commons = require("./commons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && error.response.data && error.response.data.location) {
    window.location = error.response.data.location;
  } else {
    return Promise.reject(error);
  }
});

var instance = _axios2.default.create({
  baseURL: window.location.origin,
  headers: { "Content-Type": "application/json" }
});

var instanceForArrayBuffer = _axios2.default.create({
  baseURL: window.location.origin,
  headers: { "Content-Type": "application/json" },
  responseType: "arraybuffer"
});

var wrapRequestBody = function wrapRequestBody(requestBody, action, customRequestInfo) {
  var authToken = (0, _localStorageUtils.getAccessToken)();

  var RequestInfo = {
    apiId: "Rainmaker",
    ver: ".01",
    ts: "",
    action: action,
    did: "1",
    key: "",
    //msgId: `20170310130900|${getLocale()}`,
    msgId: "20170310130900|en_IN",
    authToken: authToken
  };
  RequestInfo = (0, _extends3.default)({}, RequestInfo, customRequestInfo);
  return Object.assign({}, { RequestInfo: RequestInfo }, requestBody);
};

var wrapRequestBodyForDept = function wrapRequestBodyForDept(requestBody, action, customRequestInfo, addReqDataKey) {
  var authToken = (0, _localStorageUtils.getAccessToken)();

  var RequestInfo = {
    apiId: "Rainmaker",
    ver: ".01",
    ts: "",
    action: action,
    did: "1",
    key: "",
    msgId: "20170310130900|en_IN",
    authToken: authToken
  };

  var reqData = {
    reqData: {
      platform: "digit",
      id: "ekmchr",
      hashTk: localStorage.getItem("generatedhash"),
      deptStatus: ""
    }
  };
  RequestInfo = (0, _extends3.default)({}, RequestInfo, reqData, customRequestInfo);
  return RequestInfo;
};

// common hearing
var wrapRequestBodyForCH = function wrapRequestBodyForCH(requestBody, action, customRequestInfo, addReqDataKey) {
  var authToken = (0, _localStorageUtils.getAccessToken)();
  var hashToken = localStorage.getItem("generatedhash");

  var RequestInfo = (0, _extends3.default)({
    hashInfo: { hashTk: hashToken, appId: "ekmchr" },
    tokenInfo: {
      RequestInfo: { authToken: authToken },
      tenantId: "km",
      locale: "en_IN",
      module: "rainmaker-common",
      applicationid: "ekmchr",
      key: "F^&$^%*&G^E$#!#$*&(*&)(_I*HNMKBJK"
      // key: "SFJNUy1Bc3NldC1EZWNsYXJhdGlvbg==",
    }
  }, customRequestInfo, requestBody);
  if (addReqDataKey) {
    return { reqData: RequestInfo };
  } else {
    return RequestInfo;
  }

  return RequestInfo;
};
// for pgr
var wrapRequestBodyForPGR = function wrapRequestBodyForPGR(requestBody, action, customRequestInfo, addReqDataKey) {
  var authToken = (0, _localStorageUtils.getAccessToken)();
  var hashToken = localStorage.getItem("generatedhash");

  var RequestInfo = (0, _extends3.default)({
    hashInfo: { hashTk: hashToken, appId: "ekmchr" },
    tokenInfo: {
      RequestInfo: { authToken: authToken },
      tenantId: "km",
      locale: "en_IN",
      module: "rainmaker-common",
      applicationid: "ekmchr",
      key: "F^&$^%*&G^E$#!#$*&(*&)(_I*HNMKBJK"
      // key: "SFJNUy1Bc3NldC1EZWNsYXJhdGlvbg==",
    }
  }, customRequestInfo, requestBody);
  if (addReqDataKey) {
    return { reqData: RequestInfo };
  } else {
    return RequestInfo;
  }

  return RequestInfo;
};

// for work flow
var wrapRequestBodyForWF = function wrapRequestBodyForWF(requestBody, action, customRequestInfo, addReqDataKey) {
  var authToken = (0, _localStorageUtils.getAccessToken)();
  var hashToken = localStorage.getItem("generatedhash");

  var RequestInfo = {
    reqData: (0, _extends3.default)({
      hashInfo: { hashTk: hashToken, appId: "ekmchr" },
      tokenInfo: {
        RequestInfo: { authToken: authToken },
        tenantId: "km",
        locale: "en_IN",
        module: "rainmaker-common",
        applicationid: "ekmchr",
        key: "F^&$^%*&G^E$#!#$*&(*&)(_I*HNMKBJK"
        //key: "SFJNUy1Bc3NldC1EZWNsYXJhdGlvbg==",
      }
    }, customRequestInfo, requestBody)
  };
  if (addReqDataKey) {
    return { reqData: RequestInfo };
  } else {
    return RequestInfo;
  }

  return RequestInfo;
};
var wrapRequestBodyBnd = function wrapRequestBodyBnd(requestBody, action, customRequestInfo) {
  var authToken = (0, _localStorageUtils.getAccessToken)();
  var userInfo = JSON.parse(localStorage.getItem("user-info"));
  var RequestInfo = {
    apiId: "Rainmaker",
    ver: ".01",
    ts: "",
    action: action,
    did: "1",
    key: "",
    msgId: "20170310130900|" + (0, _localStorageUtils.getLocale)(),
    // requesterId: "",
    authToken: authToken,
    userInfo: userInfo
  };
  RequestInfo = (0, _extends3.default)({}, RequestInfo, customRequestInfo);
  return Object.assign({}, { RequestInfo: RequestInfo }, requestBody);
};

var wrapRequestBodyForPRKMC = function wrapRequestBodyForPRKMC(requestBody, action, customRequestInfo) {
  var authToken = (0, _localStorageUtils.getAccessToken)();
  var officeId = window.localStorage.getItem("officeId") || "0";
  var roleId = window.localStorage.getItem("roleId") || "0";
  var RequestInfo = {
    apiId: "Rainmaker",
    ver: ".01",
    ts: "",
    action: action,
    did: "1",
    key: "",
    msgId: "20170310130900|" + (0, _localStorageUtils.getLocale)(),
    // requesterId: "",
    officeId: officeId,
    roleId: roleId,
    authToken: authToken
  };
  RequestInfo = (0, _extends3.default)({}, RequestInfo, customRequestInfo);
  return Object.assign({}, { RequestInfo: RequestInfo }, requestBody);
};

var wrapRequestBodyForPT = function wrapRequestBodyForPT(requestBody, action, customRequestInfo) {
  var authToken = (0, _localStorageUtils.getAccessToken)();
  var officeId = window.localStorage.getItem("officeId") || "0";
  var roleId = window.localStorage.getItem("roleId") || "0";
  var RequestInfo = {
    apiId: "Rainmaker",
    ver: ".01",
    ts: "",
    action: action,
    did: "1",
    key: "",
    msgId: "20170310130900|" + (0, _localStorageUtils.getLocale)(),
    authToken: authToken
  };
  if (process.env.REACT_APP_NAME == "Employee") RequestInfo = (0, _extends3.default)({}, RequestInfo, { officeId: officeId, roleId: roleId });

  RequestInfo = (0, _extends3.default)({}, RequestInfo, customRequestInfo);
  return Object.assign({}, { RequestInfo: RequestInfo }, requestBody);
};

var wrapRequestBodyForAssessee = function wrapRequestBodyForAssessee(requestBody, action, customRequestInfo) {
  var authToken = (0, _localStorageUtils.getAccessToken)();
  var officeId = window.localStorage.getItem("officeId") || "0";
  var roleId = window.localStorage.getItem("roleId") || "0";
  var RequestInfo = {
    apiId: "Rainmaker",
    ver: ".01",
    ts: "",
    action: action,
    did: "1",
    key: "",
    msgId: "20170310130900|" + (0, _localStorageUtils.getLocale)(),
    authToken: authToken
  };

  RequestInfo = (0, _extends3.default)({}, RequestInfo, customRequestInfo);
  return Object.assign({}, { RequestInfo: RequestInfo }, requestBody);
};

var multiHttpRequest = exports.multiHttpRequest = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var endPoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    var apiError, response, responseStatus, _error$response$, data, status;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiError = "Api Error";


            if (headers) instance.defaults = Object.assign(instance.defaults, { headers: headers });

            _context.prev = 2;
            _context.next = 5;
            return _axios2.default.all(requestBody.map(function (requestB, index) {
              if (queryObject && queryObject[index] && queryObject[index].length) {
                endPoint[index] = (0, _commons.addQueryArg)(endPoint[index], queryObject[index]);
              }
              return instance.post(endPoint[index], wrapRequestBody(requestB, action, customRequestInfo));
            }));

          case 5:
            response = _context.sent;
            responseStatus = parseInt(response && Array.isArray(response) && response.length > 0 && response[0] && response[0].status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", response && response.map(function (resp) {
              return resp.data;
            }));

          case 9:
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            _error$response$ = _context.t0.response[0], data = _error$response$.data, status = _error$response$.status;

            if ((0, _commons.hasTokenExpired)(status, data)) {
              apiError = "INVALID_TOKEN";
            } else {
              apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;
            }

          case 15:
            throw new Error(apiError);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined, [[2, 11]]);
  }));

  return function multiHttpRequest() {
    return _ref.apply(this, arguments);
  };
}();

// Specific for common hearing
var httpRequestCH = exports.httpRequestCH = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var ignoreTenantId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var isGetMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
    var requireFullRequest = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
    var addReqDataKey = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;

    var tenantId, apiError, getResponse, getResponseStatus, response, responseStatus, _error$response, data, status;

    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            apiError = "Api Error";


            if (headers) instance.defaults = Object.assign(instance.defaults, { headers: headers });

            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({
                key: "tenantId",
                value: tenantId
              });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }

            _context2.prev = 5;

            if (!isGetMethod) {
              _context2.next = 15;
              break;
            }

            _context2.next = 9;
            return instance.get(endPoint, requireFullRequest ? requestBody : wrapRequestBodyForCH(requestBody, action, customRequestInfo, addReqDataKey));

          case 9:
            getResponse = _context2.sent;
            getResponseStatus = parseInt(getResponse.status, 10);

            if (!(getResponseStatus === 200 || getResponseStatus === 201)) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", getResponse.data);

          case 13:
            _context2.next = 21;
            break;

          case 15:
            _context2.next = 17;
            return instance.post(endPoint, requireFullRequest ? requestBody : wrapRequestBodyForCH(requestBody, action, customRequestInfo, addReqDataKey));

          case 17:
            response = _context2.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context2.next = 21;
              break;
            }

            return _context2.abrupt("return", response.data);

          case 21:
            _context2.next = 27;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](5);
            _error$response = _context2.t0.response, data = _error$response.data, status = _error$response.status;

            if ((0, _commons.hasTokenExpired)(status, data)) {
              apiError = "INVALID_TOKEN";
            } else {
              apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;
            }

          case 27:
            throw new Error(apiError);

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[5, 23]]);
  }));

  return function httpRequestCH(_x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();
// Specific for pgr
var httpRequestPGR = exports.httpRequestPGR = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var ignoreTenantId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var isGetMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
    var requireFullRequest = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
    var addReqDataKey = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;

    var tenantId, apiError, getResponse, getResponseStatus, response, responseStatus, _error$response2, data, status;

    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            apiError = "Api Error";


            if (headers) instance.defaults = Object.assign(instance.defaults, { headers: headers });

            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({
                key: "tenantId",
                value: tenantId
              });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }

            _context3.prev = 5;

            if (!isGetMethod) {
              _context3.next = 15;
              break;
            }

            _context3.next = 9;
            return instance.get(endPoint, requireFullRequest ? requestBody : wrapRequestBodyForPGR(requestBody, action, customRequestInfo, addReqDataKey));

          case 9:
            getResponse = _context3.sent;
            getResponseStatus = parseInt(getResponse.status, 10);

            if (!(getResponseStatus === 200 || getResponseStatus === 201)) {
              _context3.next = 13;
              break;
            }

            return _context3.abrupt("return", getResponse.data);

          case 13:
            _context3.next = 21;
            break;

          case 15:
            _context3.next = 17;
            return instance.post(endPoint, requireFullRequest ? requestBody : wrapRequestBodyForPGR(requestBody, action, customRequestInfo, addReqDataKey));

          case 17:
            response = _context3.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context3.next = 21;
              break;
            }

            return _context3.abrupt("return", response.data);

          case 21:
            _context3.next = 27;
            break;

          case 23:
            _context3.prev = 23;
            _context3.t0 = _context3["catch"](5);
            _error$response2 = _context3.t0.response, data = _error$response2.data, status = _error$response2.status;

            if ((0, _commons.hasTokenExpired)(status, data)) {
              apiError = "INVALID_TOKEN";
            } else {
              apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;
            }

          case 27:
            throw new Error(apiError);

          case 28:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[5, 23]]);
  }));

  return function httpRequestPGR(_x16, _x17) {
    return _ref3.apply(this, arguments);
  };
}();
// Specific for work flow
var httpRequestWF = exports.httpRequestWF = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var ignoreTenantId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var isGetMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
    var requireFullRequest = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
    var addReqDataKey = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;

    var tenantId, apiError, getResponse, getResponseStatus, response, responseStatus, _error$response3, data, status;

    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            apiError = "Api Error";


            if (headers) instance.defaults = Object.assign(instance.defaults, { headers: headers });

            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({
                key: "tenantId",
                value: tenantId
              });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }

            _context4.prev = 5;

            if (!isGetMethod) {
              _context4.next = 15;
              break;
            }

            _context4.next = 9;
            return instance.get(endPoint, requireFullRequest ? requestBody : wrapRequestBodyForWF(requestBody, action, customRequestInfo, addReqDataKey));

          case 9:
            getResponse = _context4.sent;
            getResponseStatus = parseInt(getResponse.status, 10);

            if (!(getResponseStatus === 200 || getResponseStatus === 201)) {
              _context4.next = 13;
              break;
            }

            return _context4.abrupt("return", getResponse.data);

          case 13:
            _context4.next = 21;
            break;

          case 15:
            _context4.next = 17;
            return instance.post(endPoint, requireFullRequest ? requestBody : wrapRequestBodyForWF(requestBody, action, customRequestInfo, addReqDataKey));

          case 17:
            response = _context4.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context4.next = 21;
              break;
            }

            return _context4.abrupt("return", response.data);

          case 21:
            _context4.next = 27;
            break;

          case 23:
            _context4.prev = 23;
            _context4.t0 = _context4["catch"](5);
            _error$response3 = _context4.t0.response, data = _error$response3.data, status = _error$response3.status;

            if ((0, _commons.hasTokenExpired)(status, data)) {
              apiError = "INVALID_TOKEN";
            } else {
              apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;
            }

          case 27:
            throw new Error(apiError);

          case 28:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[5, 23]]);
  }));

  return function httpRequestWF(_x26, _x27) {
    return _ref4.apply(this, arguments);
  };
}();

var httpRequest = exports.httpRequest = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var ignoreTenantId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var isGetMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    var tenantId, apiError, getResponse, getResponseStatus, response, responseStatus, _error$response4, data, status;

    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            apiError = "Api Error";


            if (headers) instance.defaults = Object.assign(instance.defaults, { headers: headers });

            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({
                key: "tenantId",
                value: tenantId
              });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }

            _context5.prev = 5;

            if (!isGetMethod) {
              _context5.next = 15;
              break;
            }

            _context5.next = 9;
            return instance.get(endPoint, wrapRequestBody(requestBody, action, customRequestInfo));

          case 9:
            getResponse = _context5.sent;
            getResponseStatus = parseInt(getResponse.status, 10);

            if (!(getResponseStatus === 200 || getResponseStatus === 201)) {
              _context5.next = 13;
              break;
            }

            return _context5.abrupt("return", getResponse.data);

          case 13:
            _context5.next = 21;
            break;

          case 15:
            _context5.next = 17;
            return instance.post(endPoint, wrapRequestBody(requestBody, action, customRequestInfo));

          case 17:
            response = _context5.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context5.next = 21;
              break;
            }

            return _context5.abrupt("return", response.data);

          case 21:
            _context5.next = 27;
            break;

          case 23:
            _context5.prev = 23;
            _context5.t0 = _context5["catch"](5);
            _error$response4 = _context5.t0.response, data = _error$response4.data, status = _error$response4.status;

            if ((0, _commons.hasTokenExpired)(status, data)) {
              apiError = "INVALID_TOKEN";
            } else {
              apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;
            }

          case 27:
            throw new Error(apiError);

          case 28:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, undefined, [[5, 23]]);
  }));

  return function httpRequest(_x36, _x37) {
    return _ref5.apply(this, arguments);
  };
}();
var httpRequestForBnd = exports.httpRequestForBnd = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var ignoreTenantId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var isGetMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    var tenantId, apiError, getResponse, getResponseStatus, response, responseStatus, _error$response5, data, status;

    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            apiError = "Api Error";


            if (headers) instance.defaults = Object.assign(instance.defaults, { headers: headers });

            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({
                key: "tenantId",
                value: tenantId
              });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }

            _context6.prev = 5;

            if (!isGetMethod) {
              _context6.next = 15;
              break;
            }

            _context6.next = 9;
            return instance.get(endPoint, wrapRequestBodyBnd(requestBody, action, customRequestInfo));

          case 9:
            getResponse = _context6.sent;
            getResponseStatus = parseInt(getResponse.status, 10);

            if (!(getResponseStatus === 200 || getResponseStatus === 201)) {
              _context6.next = 13;
              break;
            }

            return _context6.abrupt("return", getResponse.data);

          case 13:
            _context6.next = 21;
            break;

          case 15:
            _context6.next = 17;
            return instance.post(endPoint, wrapRequestBodyBnd(requestBody, action, customRequestInfo));

          case 17:
            response = _context6.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context6.next = 21;
              break;
            }

            return _context6.abrupt("return", response.data);

          case 21:
            _context6.next = 27;
            break;

          case 23:
            _context6.prev = 23;
            _context6.t0 = _context6["catch"](5);
            _error$response5 = _context6.t0.response, data = _error$response5.data, status = _error$response5.status;

            if ((0, _commons.hasTokenExpired)(status, data)) {
              apiError = "INVALID_TOKEN";
            } else {
              apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;
            }

          case 27:
            throw new Error(apiError);

          case 28:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, undefined, [[5, 23]]);
  }));

  return function httpRequestForBnd(_x44, _x45) {
    return _ref6.apply(this, arguments);
  };
}();
var httpRequestForPTKMC = exports.httpRequestForPTKMC = function () {
  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var ignoreTenantId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var isGetMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    var tenantId, apiError, returnObject, getResponse, getResponseStatus, response, responseStatus, _error$response6, data, status;

    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            apiError = "Api Error";


            if (headers) instance.defaults = Object.assign(instance.defaults, { headers: headers });

            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({
                key: "tenantId",
                value: tenantId
              });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }
            returnObject = {};
            _context7.prev = 6;

            if (!isGetMethod) {
              _context7.next = 20;
              break;
            }

            _context7.next = 10;
            return instance.get(endPoint, wrapRequestBodyForPRKMC(requestBody, action, customRequestInfo));

          case 10:
            getResponse = _context7.sent;
            getResponseStatus = parseInt(getResponse.status, 10);

            if (!(getResponseStatus === 200 || getResponseStatus === 201)) {
              _context7.next = 18;
              break;
            }

            returnObject.data = getResponse.data;
            returnObject.status = getResponseStatus;
            returnObject.type = "try";
            returnObject.tokenStatus = "valid";
            return _context7.abrupt("return", getResponse.data);

          case 18:
            _context7.next = 26;
            break;

          case 20:
            _context7.next = 22;
            return instance.post(endPoint, wrapRequestBodyForPRKMC(requestBody, action, customRequestInfo));

          case 22:
            response = _context7.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context7.next = 26;
              break;
            }

            return _context7.abrupt("return", response.data);

          case 26:
            _context7.next = 46;
            break;

          case 28:
            _context7.prev = 28;
            _context7.t0 = _context7["catch"](6);
            _error$response6 = _context7.t0.response, data = _error$response6.data, status = _error$response6.status;

            if (!(0, _commons.hasTokenExpired)(status, data)) {
              _context7.next = 40;
              break;
            }

            apiError = "INVALID_TOKEN";
            returnObject.data = data;
            returnObject.status = status;
            returnObject.tokenStatus = "invalid";
            returnObject.type = "catch";

            return _context7.abrupt("return", returnObject);

          case 40:
            apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;

            returnObject.data = data;
            returnObject.status = status;
            returnObject.tokenStatus = "valid";
            returnObject.type = "catch";

            return _context7.abrupt("return", returnObject);

          case 46:
            throw new Error(apiError);

          case 47:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, undefined, [[6, 28]]);
  }));

  return function httpRequestForPTKMC(_x52, _x53) {
    return _ref7.apply(this, arguments);
  };
}();

// VIEW: Function that is responsible for all api calls in PT Module
var httpRequestForPT = exports.httpRequestForPT = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var ignoreTenantId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var isGetMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    var tenantId, apiError, returnObject, getResponse, getResponseStatus, response, responseStatus, _error$response7, data, status;

    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            apiError = "Api Error";


            if (headers) instance.defaults = Object.assign(instance.defaults, { headers: headers });

            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({ key: "tenantId", value: tenantId });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }
            returnObject = {};
            _context8.prev = 6;

            if (!isGetMethod) {
              _context8.next = 20;
              break;
            }

            _context8.next = 10;
            return instance.get(endPoint, wrapRequestBodyForPT(requestBody, action, customRequestInfo));

          case 10:
            getResponse = _context8.sent;
            getResponseStatus = parseInt(getResponse.status, 10);

            if (!(getResponseStatus === 200 || getResponseStatus === 201)) {
              _context8.next = 18;
              break;
            }

            returnObject.data = getResponse.data;
            returnObject.status = getResponseStatus;
            returnObject.type = "try";
            returnObject.tokenStatus = "valid";
            return _context8.abrupt("return", returnObject);

          case 18:
            _context8.next = 30;
            break;

          case 20:
            _context8.next = 22;
            return instance.post(endPoint, wrapRequestBodyForPT(requestBody, action, customRequestInfo));

          case 22:
            response = _context8.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context8.next = 30;
              break;
            }

            returnObject.data = response.data;
            returnObject.status = responseStatus;
            returnObject.tokenStatus = "valid";
            returnObject.type = "try";
            return _context8.abrupt("return", returnObject);

          case 30:
            _context8.next = 50;
            break;

          case 32:
            _context8.prev = 32;
            _context8.t0 = _context8["catch"](6);
            _error$response7 = _context8.t0.response, data = _error$response7.data, status = _error$response7.status;

            if (!(0, _commons.hasTokenExpired)(status, data)) {
              _context8.next = 44;
              break;
            }

            apiError = "INVALID_TOKEN";
            returnObject.data = data;
            returnObject.status = status;
            returnObject.tokenStatus = "invalid";
            returnObject.type = "catch";

            return _context8.abrupt("return", returnObject);

          case 44:
            apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;

            returnObject.data = data;
            returnObject.status = status;
            returnObject.tokenStatus = "valid";
            returnObject.type = "catch";

            return _context8.abrupt("return", returnObject);

          case 50:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, undefined, [[6, 32]]);
  }));

  return function httpRequestForPT(_x60, _x61) {
    return _ref8.apply(this, arguments);
  };
}();

var httpRequestForAssessee = exports.httpRequestForAssessee = function () {
  var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var ignoreTenantId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var isGetMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    var tenantId, apiError, returnObject, getResponse, getResponseStatus, response, responseStatus, _error$response8, data, status;

    return _regenerator2.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            apiError = "Api Error";


            if (headers) instance.defaults = Object.assign(instance.defaults, { headers: headers });

            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({ key: "tenantId", value: tenantId });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }
            returnObject = {};
            _context9.prev = 6;

            if (!isGetMethod) {
              _context9.next = 20;
              break;
            }

            _context9.next = 10;
            return instance.get(endPoint, wrapRequestBodyForAssessee(requestBody, action, customRequestInfo));

          case 10:
            getResponse = _context9.sent;
            getResponseStatus = parseInt(getResponse.status, 10);

            if (!(getResponseStatus === 200 || getResponseStatus === 201)) {
              _context9.next = 18;
              break;
            }

            returnObject.data = getResponse.data;
            returnObject.status = getResponseStatus;
            returnObject.type = "try";
            returnObject.tokenStatus = "valid";
            return _context9.abrupt("return", returnObject);

          case 18:
            _context9.next = 30;
            break;

          case 20:
            _context9.next = 22;
            return instance.post(endPoint, wrapRequestBodyForAssessee(requestBody, action, customRequestInfo));

          case 22:
            response = _context9.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context9.next = 30;
              break;
            }

            returnObject.data = response.data;
            returnObject.status = responseStatus;
            returnObject.tokenStatus = "valid";
            returnObject.type = "try";
            return _context9.abrupt("return", returnObject);

          case 30:
            _context9.next = 50;
            break;

          case 32:
            _context9.prev = 32;
            _context9.t0 = _context9["catch"](6);
            _error$response8 = _context9.t0.response, data = _error$response8.data, status = _error$response8.status;

            if (!(0, _commons.hasTokenExpired)(status, data)) {
              _context9.next = 44;
              break;
            }

            apiError = "INVALID_TOKEN";
            returnObject.data = data;
            returnObject.status = status;
            returnObject.tokenStatus = "invalid";
            returnObject.type = "catch";

            return _context9.abrupt("return", returnObject);

          case 44:
            apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;

            returnObject.data = data;
            returnObject.status = status;
            returnObject.tokenStatus = "valid";
            returnObject.type = "catch";

            return _context9.abrupt("return", returnObject);

          case 50:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, undefined, [[6, 32]]);
  }));

  return function httpRequestForAssessee(_x68, _x69) {
    return _ref9.apply(this, arguments);
  };
}();

// VIEW: Download PDF
var httpRequestForArrayBuffer = exports.httpRequestForArrayBuffer = function () {
  var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var ignoreTenantId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var isGetMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    var tenantId, apiError, returnObject, getResponse, getResponseStatus, response, responseStatus, _error$response9, data, status, text;

    return _regenerator2.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            apiError = "Api Error";


            if (headers) instanceForArrayBuffer.defaults = Object.assign(instanceForArrayBuffer.defaults, {
              headers: headers
            });

            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({
                key: "tenantId",
                value: tenantId
              });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }
            // FIXME: handle for 400
            returnObject = {};
            _context10.prev = 6;

            if (!isGetMethod) {
              _context10.next = 21;
              break;
            }

            _context10.next = 10;
            return instanceForArrayBuffer.get(endPoint, wrapRequestBody(requestBody, action, customRequestInfo));

          case 10:
            getResponse = _context10.sent;
            getResponseStatus = parseInt(getResponse.status, 10);

            if (!(getResponseStatus === 200 || getResponseStatus === 201)) {
              _context10.next = 19;
              break;
            }

            returnObject.data = getResponse.data;
            returnObject.headers = getResponse.headers;
            returnObject.status = getResponseStatus;
            returnObject.type = "try";
            returnObject.tokenStatus = "valid";
            return _context10.abrupt("return", returnObject);

          case 19:
            _context10.next = 32;
            break;

          case 21:
            _context10.next = 23;
            return instanceForArrayBuffer.post(endPoint, wrapRequestBody(requestBody, action, customRequestInfo));

          case 23:
            response = _context10.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context10.next = 32;
              break;
            }

            returnObject.data = response.data;
            returnObject.headers = response.headers;
            returnObject.status = responseStatus;
            returnObject.tokenStatus = "valid";
            returnObject.type = "try";
            return _context10.abrupt("return", returnObject);

          case 32:
            _context10.next = 53;
            break;

          case 34:
            _context10.prev = 34;
            _context10.t0 = _context10["catch"](6);
            _error$response9 = _context10.t0.response, data = _error$response9.data, status = _error$response9.status;

            if (!(0, _commons.hasTokenExpired)(status, data)) {
              _context10.next = 46;
              break;
            }

            apiError = "INVALID_TOKEN";
            returnObject.data = data;
            returnObject.status = status;
            returnObject.tokenStatus = "invalid";
            returnObject.type = "catch";

            return _context10.abrupt("return", returnObject);

          case 46:
            apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;

            returnObject.data = data;
            returnObject.status = status;
            returnObject.tokenStatus = "valid";
            returnObject.type = "catch";
            // Handle non-200/201 response here
            if (status === 400) {
              // Convert ArrayBuffer to readable format if status is 400
              if (status === 400 && data instanceof ArrayBuffer) {
                text = new TextDecoder().decode(data);

                try {
                  returnObject.data = JSON.parse(text);
                } catch (e) {
                  returnObject.data = text;
                }
              } else {
                returnObject.data = data;
              }
              returnObject.headers = headers;
              returnObject.status = status;
              returnObject.type = "catch";
              returnObject.tokenStatus = "valid";
            }
            //   apiError =
            //     (data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message) ||
            //     (data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message) ||
            //     (data.hasOwnProperty("error_description") && data.error_description) ||
            //     apiError;

            //   returnObject.data = data;
            //   returnObject.status = status;
            //   returnObject.tokenStatus = "valid";
            //   returnObject.type = "catch";

            return _context10.abrupt("return", returnObject);

          case 53:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, undefined, [[6, 34]]);
  }));

  return function httpRequestForArrayBuffer(_x76, _x77) {
    return _ref10.apply(this, arguments);
  };
}();

var uploadFile = exports.uploadFile = function () {
  var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(endPoint, module, file, ulbLevel) {
    var tenantId, uploadInstance, requestParams, requestBody, tenantInfo, response, responseStatus, fileStoreIds, responseData, files;
    return _regenerator2.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            // Bad idea to fetch from local storage, change as feasible
            tenantId = (0, _localStorageUtils.getTenantId)() ? ulbLevel ? _common2.default.tenantId : _common2.default.tenantId : "";
            uploadInstance = _axios2.default.create({
              baseURL: window.location.origin,
              headers: {
                "Content-Type": "multipart/form-data",
                "auth-token": (0, _localStorageUtils.getAccessToken)()
              }
            });
            requestParams = { tenantId: tenantId, module: module, file: file };
            requestBody = (0, _commons.prepareForm)(requestParams);
            _context11.prev = 4;
            tenantInfo = _common2.default.singleInstance ? "?tenantId=" + _common2.default.tenantId : "";
            _context11.next = 8;
            return uploadInstance.post("" + endPoint + tenantInfo, requestBody);

          case 8:
            response = _context11.sent;
            responseStatus = parseInt(response.status, 10);
            fileStoreIds = [];

            if (!(responseStatus === 201)) {
              _context11.next = 16;
              break;
            }

            responseData = response.data;
            files = responseData.files || [];

            fileStoreIds = files.map(function (f) {
              return f.fileStoreId;
            });
            return _context11.abrupt("return", fileStoreIds[0]);

          case 16:
            _context11.next = 21;
            break;

          case 18:
            _context11.prev = 18;
            _context11.t0 = _context11["catch"](4);
            throw new Error(_context11.t0);

          case 21:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, undefined, [[4, 18]]);
  }));

  return function uploadFile(_x84, _x85, _x86, _x87) {
    return _ref11.apply(this, arguments);
  };
}();

// VIEW: Function that is responsible for all upload api calls in PT Module
var uploadFileForPt = exports.uploadFileForPt = function () {
  var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(endPoint, documentType, caseNo, documentId, docType, userId, file, keyName, queryNo, queryYear, status, bookNo, roCode, districtCode) {
    var formData, uploadInstance, response, responseStatus;
    return _regenerator2.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            formData = new FormData();

            formData.append("userId", userId);
            formData.append("documentType", documentType);
            formData.append("documentId", caseNo + "@" + documentId + "@" + docType);
            formData.append(keyName || "file", file);

            if (status === "Y") {
              formData.append("queryYear", queryYear);
              formData.append("queryNo", queryNo);
              formData.append("isAvailable", status);
            } else if (status === "N") {
              formData.append("deedNo", queryNo);
              formData.append("deedYear", queryYear);
              formData.append("bookno", bookNo);
              formData.append("roCode", roCode);
              formData.append("districtCode", districtCode);
              formData.append("isAvailable", status);
              formData.append(keyName || "file", file);
            } else {
              formData.append(keyName || "file", file);
            }

            uploadInstance = _axios2.default.create({
              baseURL: window.location.origin,
              headers: {
                "Content-Type": "multipart/form-data",
                "auth-token": (0, _localStorageUtils.getAccessToken)()
              }
            });
            _context12.prev = 7;
            _context12.next = 10;
            return uploadInstance.post(endPoint, formData);

          case 10:
            response = _context12.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context12.next = 16;
              break;
            }

            return _context12.abrupt("return", response.data);

          case 16:
            throw new Error("Error uploading file.");

          case 17:
            _context12.next = 22;
            break;

          case 19:
            _context12.prev = 19;
            _context12.t0 = _context12["catch"](7);
            throw new Error(_context12.t0);

          case 22:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, undefined, [[7, 19]]);
  }));

  return function uploadFileForPt(_x88, _x89, _x90, _x91, _x92, _x93, _x94, _x95, _x96, _x97, _x98, _x99, _x100, _x101) {
    return _ref12.apply(this, arguments);
  };
}();

var uploadSingleFilePt = exports.uploadSingleFilePt = function () {
  var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(endPoint, hearingMethod, assseseeNo, noticeNo, file, keyName) {
    var uploadInstance, response, responseStatus;
    return _regenerator2.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            uploadInstance = _axios2.default.create({
              baseURL: window.location.origin,
              headers: {
                "Content-Type": "multipart/form-data",
                "auth-token": (0, _localStorageUtils.getAccessToken)()
              }
            });
            _context13.prev = 1;
            _context13.next = 4;
            return uploadInstance.post(endPoint, {
              params: { hearingMethod: hearingMethod, assseseeNo: assseseeNo, noticeNo: noticeNo }
            });

          case 4:
            response = _context13.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context13.next = 10;
              break;
            }

            return _context13.abrupt("return", response.data);

          case 10:
            throw new Error("Error uploading file.");

          case 11:
            _context13.next = 16;
            break;

          case 13:
            _context13.prev = 13;
            _context13.t0 = _context13["catch"](1);
            throw new Error(_context13.t0);

          case 16:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, undefined, [[1, 13]]);
  }));

  return function uploadSingleFilePt(_x102, _x103, _x104, _x105, _x106, _x107) {
    return _ref13.apply(this, arguments);
  };
}();

var uploadFileHandler = exports.uploadFileHandler = function () {
  var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(endPoint, formData) {
    var uploadInstance, response, responseStatus;
    return _regenerator2.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            uploadInstance = _axios2.default.create({
              baseURL: window.location.origin,
              headers: {
                "Content-Type": "multipart/form-data",
                "auth-token": (0, _localStorageUtils.getAccessToken)()
              }
            });
            _context14.prev = 1;
            _context14.next = 4;
            return uploadInstance.post(endPoint, formData);

          case 4:
            response = _context14.sent;
            responseStatus = parseInt(response.status, 10);

            if (![200, 201].includes(responseStatus)) {
              _context14.next = 10;
              break;
            }

            return _context14.abrupt("return", response.data);

          case 10:
            throw new Error("Error uploading file.");

          case 11:
            _context14.next = 16;
            break;

          case 13:
            _context14.prev = 13;
            _context14.t0 = _context14["catch"](1);
            throw new Error(_context14.t0);

          case 16:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, undefined, [[1, 13]]);
  }));

  return function uploadFileHandler(_x108, _x109) {
    return _ref14.apply(this, arguments);
  };
}();

var loginRequest = exports.loginRequest = function () {
  var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15() {
    var username = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var refreshToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var grantType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "password";
    var tenantId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
    var userType = arguments[5];

    var loginInstance, apiError, params, response, responseStatus, _error$response10, data, status;

    return _regenerator2.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            tenantId = tenantId ? tenantId : _common2.default.tenantId;
            loginInstance = _axios2.default.create({
              baseURL: window.location.origin,
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Basic ZWdvdi11c2VyLWNsaWVudDo="
              }
            });
            apiError = "Api Error";
            params = new URLSearchParams();

            username && params.append("username", username);
            password && params.append("password", password);
            refreshToken && params.append("refresh_token", refreshToken);
            params.append("grant_type", grantType);
            params.append("scope", "read");
            params.append("tenantId", tenantId);
            userType && params.append("userType", userType);

            _context15.prev = 11;
            _context15.next = 14;
            return loginInstance.post("/user/oauth/token", params);

          case 14:
            response = _context15.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context15.next = 19;
              break;
            }

            localStorage.setItem("citizen.userRequestObject", JSON.stringify(response.data.UserRequest));
            return _context15.abrupt("return", response.data);

          case 19:
            _context15.next = 25;
            break;

          case 21:
            _context15.prev = 21;
            _context15.t0 = _context15["catch"](11);
            _error$response10 = _context15.t0.response, data = _error$response10.data, status = _error$response10.status;

            if (status === 400) {
              apiError = data.hasOwnProperty("error_description") && data.error_description || apiError;
            }

          case 25:
            throw new Error(apiError);

          case 26:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, undefined, [[11, 21]]);
  }));

  return function loginRequest() {
    return _ref15.apply(this, arguments);
  };
}();

var loginRequestEmployee = exports.loginRequestEmployee = function () {
  var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16() {
    var username = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var refreshToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var grantType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "password";
    var tenantId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
    var userType = arguments[5];
    var otp = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "";

    var otpResponse, ipAddress, otpDetails, params, loginInstance, apiError, response, responseStatus, _ref17, status, encryptedText, decryptionKeyHex, keyBytes, decryptedDataBytes, decryptedData, dataArray;

    return _regenerator2.default.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            tenantId = tenantId ? tenantId : _common2.default.tenantId;
            otpResponse = localStorage.getItem("otpResponse");
            ipAddress = localStorage.getItem("ipAddress");
            otpDetails = JSON.parse(otpResponse);
            params = {
              deviceIP: ipAddress ? ipAddress : "",
              mobileNumber: "**********",
              // mobileNumber: otpDetails.mobileNumber,
              token: otpDetails.token,
              otp: otp,
              username: username,
              password: password,
              grant_type: "password",
              scope: "read",
              tenantId: tenantId,
              userType: userType
            };
            loginInstance = _axios2.default.create({
              baseURL: window.location.origin,
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic ZWdvdi11c2VyLWNsaWVudDo="
              },
              data: {
                mobileNumber: "**********",
                //   mobileNumber: otpDetails.mobileNumber,
                token: otpDetails.token,
                otp: otp,
                username: username,
                password: password,
                grant_type: "password",
                scope: "read",
                tenantId: tenantId,
                userType: userType
              }
            });
            apiError = "Api Error";
            //   var params = new URLSearchParams();
            //   username && params.append("username", username);
            //   password && params.append("password", password);
            //   refreshToken && params.append("refresh_token", refreshToken);
            //   params.append("grant_type", grantType);
            //   params.append("scope", "read");
            //   params.append("tenantId", tenantId);
            //   userType && params.append("userType", userType);

            if (!(otp != "")) {
              _context16.next = 41;
              break;
            }

            _context16.prev = 8;
            _context16.next = 11;
            return loginInstance.post("pwc-db-services/validateMobileOtp", params);

          case 11:
            response = _context16.sent;
            responseStatus = parseInt(response && response.status, 10);
            _ref17 = response && response.data, status = _ref17.status;

            if (!(status == 309)) {
              _context16.next = 16;
              break;
            }

            throw new Error(response && response.data && response.data.data && response.data.data);

          case 16:
            if (!(status == 501)) {
              _context16.next = 18;
              break;
            }

            throw new Error(response && response.data && response.data.data && response.data.data.data);

          case 18:
            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context16.next = 33;
              break;
            }

            encryptedText = response.data.status2;
            decryptionKeyHex = "d0b3eb613f21af77972a29fe0e8c83f4a0a88a5b4053ce0d9160a0540451754b";
            keyBytes = _cryptoJs2.default.enc.Hex.parse(decryptionKeyHex);
            decryptedDataBytes = _cryptoJs2.default.AES.decrypt(encryptedText, keyBytes, {
              mode: _cryptoJs2.default.mode.ECB,
              padding: _cryptoJs2.default.pad.Pkcs7 // Use PKCS#7 padding
            });
            decryptedData = decryptedDataBytes.toString(_cryptoJs2.default.enc.Utf8);
            dataArray = decryptedData.split("|");

            localStorage.setItem("expiryStatus", JSON.stringify(response.data && response.data.expiryStatus && response.data.expiryStatus));
            localStorage.setItem("expiryValue", 1);

            if (!(otp == dataArray[2] && otpDetails.token == dataArray[3])) {
              _context16.next = 32;
              break;
            }

            localStorage.setItem("citizen.userRequestObject", JSON.stringify(response.data.data.UserRequest));

            return _context16.abrupt("return", response && response.data.data);

          case 32:
            window.location.replace(window.basename + "/error-selection");
            //    const requestBody = {
            //      access_token: response.data.data.access_token,
            //      userName: response.data.data.UserRequest.userName,
            //    };
            //    // const continueResponse = await httpRequest("post", "/user/_logout", "", [], requestBody);
            //    const continueResponse = await httpRequestForPT("/user/_logout", "", [], requestBody, [], {}, true);
            //    if (continueResponse.status == 200) {

            //      store.dispatch(
            //        toggleSnackbarAndSetText(
            //          true,
            //          { labelName: "Re-Login Again", labelKey: "Re-Login Again" },
            //          "error"
            //        )
            //      );
            //      window.location.replace(`${window.basename}/language-selection`);

            //    } else {
            //      store.dispatch(
            //        toggleSnackbarAndSetText(
            //          true,
            //          { labelName: "Note:Request to clear browser cache and relogin", labelKey: "Note:Request to clear browser cache and relogin" },
            //          "error"
            //        )
            //      );

            //    }

          case 33:
            _context16.next = 39;
            break;

          case 35:
            _context16.prev = 35;
            _context16.t0 = _context16["catch"](8);

            console.log("error==>", _context16.t0);
            // const { data, status } = error.response;
            throw new Error(_context16.t0);

          case 39:
            _context16.next = 42;
            break;

          case 41:
            throw new Error("Otp field should not be empty");

          case 42:
            throw new Error(apiError);

          case 43:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, undefined, [[8, 35]]);
  }));

  return function loginRequestEmployee() {
    return _ref16.apply(this, arguments);
  };
}();

var commonApiPost = exports.commonApiPost = function commonApiPost(context) {
  var queryObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var doNotOverride = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var isTimeLong = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var noPageSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var authToken = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "";
  var userInfo = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
  var isStateLevel = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  var offset = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;

  // const RequestInfo = {
  //   apiId: "Rainmaker",
  //   ver: ".01",
  //   ts: "",
  //   did: "1",
  //   key: "",
  //   msgId: "20170310130900|en_IN",
  //   requesterId: "",
  //   authToken,
  // };
  var RequestInfo = {
    apiId: "emp",
    ver: "1.0",
    ts: "",
    action: "create",
    did: "1",
    key: "abcdkey",
    msgId: "20170310130900",
    requesterId: "",
    authToken: ""
  };

  // VIEW: The "property-services" string concatted only for PT module
  var url;
  if (context.includes("rainmaker-pt")) {
    url = "pt-report-services" + context;
  } else if (context.includes("rainmaker-hearing")) {
    url = "common-hearing" + context;
  } else if (context.includes("rainmaker-lokadalat")) {
    url = "lok-adalat" + context;
  } else url = context;

  if (url && url[url.length - 1] === "/") url = url.substring(0, url.length - 1);
  if (!doNotOverride) {
    if (url.split("?").length > 1) {
      url += "&tenantId=" + ((0, _localStorageUtils.getTenantId)() ? isStateLevel ? _common2.default.tenantId : _common2.default.tenantId : "default");
    } else {
      url += "?tenantId=" + ((0, _localStorageUtils.getTenantId)() ? isStateLevel ? _common2.default.tenantId : _common2.default.tenantId : "default");
    }
  } else {
    url += "?";
  }
  for (var variable in queryObject) {
    if (typeof queryObject[variable] !== "undefined") {
      url += "&" + variable + "=" + queryObject[variable];
    }
  }

  if (/_search/.test(context) && !noPageSize) {
    url += "&pageSize=200";
  } else {
    url += "&pageSize=" + noPageSize;
  }
  if (url.indexOf("rainmaker-bpa") > -1) {
    url = "/bpa-services" + url;
  }
  url += "&offset=" + offset;

  RequestInfo.authToken = (0, _localStorageUtils.getAccessToken)();
  if (isTimeLong) {
    RequestInfo.ts = new Date().getTime();
  }

  if (authToken) {
    RequestInfo["authToken"] = authToken;
  }
  body["RequestInfo"] = RequestInfo;

  if (userInfo) {
    body["RequestInfo"]["userInfo"] = userInfo;
  }

  return instance.post(url, body).then(function (response) {
    return response.data;
  }).catch(function (response) {
    try {
      if (response && response.response && response.response.data && response.response.data[0] && response.response.data[0].error) {
        var _err = response.response.data[0].error.message || "";
        if (response.response.data[0].error.errorFields && Object.keys(response.response.data[0].error.errorFields).length) {
          for (var i = 0; i < response.response.data[0].error.errorFields.length; i++) {
            _err += "\n " + response.response.data[0].error.errorFields[i].message + " ";
          }
          throw new Error(_err);
        }
      } else if (response && response.response && response.response.data && response.response.data.error) {
        // let _err = common.translate(response.response.data.error.fields[0].code);
        var _err2 = "";

        _err2 = response.response.data.error.message ? response.response.data.error.fields ? "a) " + extractErrorMsg(response.response.data.error, "message", "description") + " : " : extractErrorMsg(response.response.data.error, "message", "description") : "";
        var fields = response.response.data.error.fields || [];
        for (var i = 0; i < fields.length; i++) {
          _err2 += i + 1 + ") " + extractErrorMsg(fields[i], "code", "message") + ".";
        }
        throw new Error(_err2);
      } else if (response && response.response && response.response.data && response.response.data.Errors) {
        // let _err = common.translate(response.response.data.error.fields[0].code);
        var _err3 = "";
        // _err=response.response.data.error.message?"a) "+extractErrorMsg(response.response.data.error, "message", "description")+" : ":"";
        // let fields=response.response.data.error.fields;
        if (response.response.data.Errors.length == 1) {
          _err3 += common.translate(response.response.data.Errors[0].message) + ".";
        } else {
          for (var i = 0; i < response.response.data.Errors.length; i++) {
            _err3 += i + 1 + ") " + common.translate(response.response.data.Errors[i].message) + ".";
          }
        }
        throw new Error(_err3);
      } else if (response && response.response && response.response.data && response.response.data.hasOwnProperty("Data")) {
        var _err4 = common.translate(response.response.data.Message) + ".";
        throw new Error(_err4);
      } else if (response && response.response && !response.response.data && response.response.status === 400) {
        if (counter == 0) {
          document.title = "eGovernments";
          var locale = (0, _localStorageUtils.getLocale)();
          var _tntId = (0, _localStorageUtils.getTenantId)() || "default";
          var lang_response = (0, _localStorageUtils.localStorageGet)("lang_response");
          localStorage.clear();
          sessionStorage.clear();
          (0, _localStorageUtils.setLocale)(locale);
          (0, _localStorageUtils.setTenantId)(_tntId);
          (0, _localStorageUtils.localStorageSet)("lang_response", lang_response);
          alert("Session expired. Please login again.");
          //localStorage.reload = true;
          throw new Error("");
        }
      } else if (response) {
        throw new Error("Oops! Something isn't right. Please try again later.");
      } else {
        throw new Error("Server returned unexpected error. Please contact system administrator.");
      }
    } catch (e) {
      if (e.message) {
        throw new Error(e.message);
      } else throw new Error("Oops! Something isn't right. Please try again later.");
    }
  });
};

var downloadPdf = function downloadPdf(blob, fileName) {
  if (window.mSewaApp && window.mSewaApp.isMsewaApp() && window.mSewaApp.downloadBase64File) {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      var base64data = reader.result;
      mSewaApp.downloadBase64File(base64data, fileName);
    };
  } else {
    var link = document.createElement("a");
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(function () {
      return URL.revokeObjectURL(link.href);
    }, 7000);
  }
};

var printPdf = function printPdf(blob) {
  if (window.mSewaApp && window.mSewaApp.isMsewaApp() && window.mSewaApp.downloadBase64File) {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      var base64data = reader.result;
      mSewaApp.downloadBase64File(base64data, "download.pdf");
    };
  } else {
    var fileURL = URL.createObjectURL(blob);
    var myWindow = window.open(fileURL);
    if (myWindow != undefined) {
      myWindow.addEventListener("load", function (event) {
        myWindow.focus();
        myWindow.print();
      });
    }
  }
};

var downloadPdfFile = exports.downloadPdfFile = function () {
  var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var customRequestInfo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var ignoreTenantId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var fileName = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "download.pdf";
    var onSuccess = arguments[7];
    var tenantId, downloadInstance, response, responseStatus;
    return _regenerator2.default.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            downloadInstance = _axios2.default.create({
              baseURL: window.location.origin,
              responseType: "arraybuffer",
              headers: {
                "Content-Type": "application/json",
                Accept: _common2.default.singleInstance ? "application/pdf,application/json" : "application/pdf"
              }
            });


            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({ key: "tenantId", value: tenantId });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }
            _context17.prev = 4;

            _store2.default.dispatch((0, _actions.showSpinner)());
            _context17.next = 8;
            return downloadInstance.post(endPoint, wrapRequestBody(requestBody, action, customRequestInfo));

          case 8:
            response = _context17.sent;
            responseStatus = parseInt(response.status, 10);


            if (responseStatus === 201 || responseStatus === 200) {
              fileName == "print" ? printPdf(new Blob([response.data], { type: "application/pdf" })) : downloadPdf(new Blob([response.data], { type: "application/pdf" }), fileName);
              onSuccess ? onSuccess() : {};
              _store2.default.dispatch((0, _actions.hideSpinner)());
            }
            _context17.next = 17;
            break;

          case 13:
            _context17.prev = 13;
            _context17.t0 = _context17["catch"](4);

            _store2.default.dispatch((0, _actions.hideSpinner)());
            throw new Error(_context17.t0);

          case 17:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, undefined, [[4, 13]]);
  }));

  return function downloadPdfFile(_x130, _x131) {
    return _ref18.apply(this, arguments);
  };
}();

// department call
var httpRequestForDept = exports.httpRequestForDept = function () {
  var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var ignoreTenantId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var isGetMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    var tenantId, apiError, getResponse, getResponseStatus, response, responseStatus, _error$response11, data, status;

    return _regenerator2.default.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            apiError = "Api Error";


            if (headers) instance.defaults = Object.assign(instance.defaults, { headers: headers });
            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({
                key: "tenantId",
                value: tenantId
              });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }

            _context18.prev = 5;

            if (!isGetMethod) {
              _context18.next = 15;
              break;
            }

            _context18.next = 9;
            return instance.get(endPoint, wrapRequestBodyForDept(requestBody, action, customRequestInfo));

          case 9:
            getResponse = _context18.sent;
            getResponseStatus = parseInt(getResponse.status, 10);

            if (![200, 201].includes(getResponseStatus)) {
              _context18.next = 13;
              break;
            }

            return _context18.abrupt("return", getResponse.data);

          case 13:
            _context18.next = 21;
            break;

          case 15:
            _context18.next = 17;
            return instance.post(endPoint, wrapRequestBodyForDept(requestBody, action, customRequestInfo));

          case 17:
            response = _context18.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context18.next = 21;
              break;
            }

            return _context18.abrupt("return", response.data);

          case 21:
            _context18.next = 27;
            break;

          case 23:
            _context18.prev = 23;
            _context18.t0 = _context18["catch"](5);
            _error$response11 = _context18.t0.response, data = _error$response11.data, status = _error$response11.status;

            if ((0, _commons.hasTokenExpired)(status, data)) {
              apiError = "INVALID_TOKEN";
            } else {
              apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;
            }

          case 27:
            throw new Error(apiError);

          case 28:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, undefined, [[5, 23]]);
  }));

  return function httpRequestForDept(_x137, _x138) {
    return _ref19.apply(this, arguments);
  };
}();
// start new method for Report API call need to set officeId and roleId on 31/05/2024
var httpRequestForArrayBufferPt = exports.httpRequestForArrayBufferPt = function () {
  var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(endPoint, action) {
    var queryObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var requestBody = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customRequestInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var ignoreTenantId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var isGetMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    var tenantId, apiError, returnObject, getResponse, getResponseStatus, response, responseStatus, _error$response12, data, status;

    return _regenerator2.default.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            tenantId = (0, _localStorageUtils.getTenantId)() || _common2.default.tenantId;
            apiError = "Api Error";


            if (headers) instanceForArrayBuffer.defaults = Object.assign(instanceForArrayBuffer.defaults, {
              headers: headers
            });

            if (!(0, _some2.default)(queryObject, ["key", "tenantId"]) && !ignoreTenantId) {
              queryObject && queryObject.push({
                key: "tenantId",
                value: tenantId
              });
            }
            if (queryObject && queryObject.length) {
              endPoint = (0, _commons.addQueryArg)(endPoint, queryObject);
            }
            // FIXME: handle for 400
            returnObject = {};
            _context19.prev = 6;

            if (!isGetMethod) {
              _context19.next = 21;
              break;
            }

            _context19.next = 10;
            return instanceForArrayBuffer.get(endPoint, wrapRequestBodyPtReport(requestBody, action, customRequestInfo));

          case 10:
            getResponse = _context19.sent;
            getResponseStatus = parseInt(getResponse.status, 10);

            if (!(getResponseStatus === 200 || getResponseStatus === 201)) {
              _context19.next = 19;
              break;
            }

            returnObject.data = getResponse.data;
            returnObject.headers = getResponse.headers;
            returnObject.status = getResponseStatus;
            returnObject.type = "try";
            returnObject.tokenStatus = "valid";
            return _context19.abrupt("return", returnObject);

          case 19:
            _context19.next = 32;
            break;

          case 21:
            _context19.next = 23;
            return instanceForArrayBuffer.post(endPoint, wrapRequestBodyPtReport(requestBody, action, customRequestInfo));

          case 23:
            response = _context19.sent;
            responseStatus = parseInt(response.status, 10);

            if (!(responseStatus === 200 || responseStatus === 201)) {
              _context19.next = 32;
              break;
            }

            returnObject.data = response.data;
            returnObject.headers = response.headers;
            returnObject.status = responseStatus;
            returnObject.tokenStatus = "valid";
            returnObject.type = "try";
            return _context19.abrupt("return", returnObject);

          case 32:
            _context19.next = 52;
            break;

          case 34:
            _context19.prev = 34;
            _context19.t0 = _context19["catch"](6);
            _error$response12 = _context19.t0.response, data = _error$response12.data, status = _error$response12.status;

            if (!(0, _commons.hasTokenExpired)(status, data)) {
              _context19.next = 46;
              break;
            }

            apiError = "INVALID_TOKEN";
            returnObject.data = data;
            returnObject.status = status;
            returnObject.tokenStatus = "invalid";
            returnObject.type = "catch";

            return _context19.abrupt("return", returnObject);

          case 46:
            apiError = data.hasOwnProperty("Errors") && data.Errors && data.Errors.length && data.Errors[0].message || data.hasOwnProperty("error") && data.error.fields && data.error.fields.length && data.error.fields[0].message || data.hasOwnProperty("error_description") && data.error_description || apiError;

            returnObject.data = data;
            returnObject.status = status;
            returnObject.tokenStatus = "valid";
            returnObject.type = "catch";

            return _context19.abrupt("return", returnObject);

          case 52:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, undefined, [[6, 34]]);
  }));

  return function httpRequestForArrayBufferPt(_x145, _x146) {
    return _ref20.apply(this, arguments);
  };
}();
var wrapRequestBodyPtReport = function wrapRequestBodyPtReport(requestBody, action, customRequestInfo) {
  var authToken = (0, _localStorageUtils.getAccessToken)();
  var officeId = window.localStorage.getItem("officeId") || "0";
  var roleId = window.localStorage.getItem("roleId") || "0";
  var RequestInfo = {
    apiId: "Rainmaker",
    ver: ".01",
    ts: "",
    roleId: roleId,
    officeId: officeId,
    action: action,
    did: "1",
    key: "",
    msgId: "20170310130900|" + (0, _localStorageUtils.getLocale)(),
    // requesterId: "",
    authToken: authToken
  };
  RequestInfo = (0, _extends3.default)({}, RequestInfo, customRequestInfo);
  return Object.assign({}, { RequestInfo: RequestInfo }, requestBody);
};
// end


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/utils/api.js
// module id = 49
// module chunks = 1137